import { EmailTemplateEventEnum } from "helpers/constants";

export const HEADER_OPTIONS = [
  {
    label: "emailing.templateConfirmation",
    type: EmailTemplateEventEnum.BOOKING_CONFIRMATION,
  },
  {
    label: "emailing.templateCancellation",
    type: EmailTemplateEventEnum.BOOKING_CANCELLATION,
  },
];
